import { GaugeChart, Spinfinity, TextLink } from '@repo/ui';
import c from 'classnames';
import { Typography } from 'components';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useKitSummaryScores from 'services/kits/useKitSummaryScores';
import styles from './GaugeChartSection.module.css';
import GaugeChartSectionModal from './GaugeChartSectionModal';

export default function GaugeChartSection() {
  const [evaluationModalOpen, setEvaluationModalOpen] = useState(false);
  const navigate = useNavigate();
  const { kitId } = useParams<{ kitId: string }>();
  const { data, isLoading } = useKitSummaryScores(kitId ?? '', 'pro_mss');

  function handleSeeMetrics() {
    if (sessionStorage)
      sessionStorage.setItem('categoryFilters', '["PRO practitioner markers"]');

    navigate(`/results/${kitId}/insights/all-insights`);
  }

  if (isLoading)
    return (
      <section className={c(styles.loadingContainer)}>
        <Spinfinity />
      </section>
    );

  if (!data || !data[0]) return null;

  return (
    <>
      <section className={c(styles.container)}>
        <Typography variant='heading-s'>Your PRO evaluation</Typography>
        <GaugeChart
          color={data[0].evaluation_color}
          label={data[0].evaluation_text}
        />
        <div className={c(styles.buttonsContainer)}>
          <TextLink
            label='About evaluation'
            iconNameRight='infoCircle'
            onClick={() => setEvaluationModalOpen(true)}
          />
          <TextLink
            label='See metrics'
            iconNameRight='chevronForward'
            onClick={handleSeeMetrics}
          />
        </div>
      </section>
      <GaugeChartSectionModal
        isOpen={evaluationModalOpen}
        onClose={() => setEvaluationModalOpen(false)}
        kitSummaryScoreData={data[0]}
      />
    </>
  );
}
